var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2019 3.28313V2.25938C4.2019 1.6125 4.72503 1.095 5.36628 1.095H13.5338C14.1807 1.095 14.6982 1.61813 14.6982 2.25938V3.28313",
    stroke: "#191D23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44995 10.905V1.56189",
    stroke: "#191D23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23364 10.905H11.6661",
    stroke: "#191D23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7825 13.5H4.11745C3.10495 13.5 2.69995 13.7033 2.69995 14.2084V15.4916C2.69995 15.9967 3.10495 16.2 4.11745 16.2H14.7825C15.795 16.2 16.2 15.9967 16.2 15.4916V14.2084C16.2 13.7033 15.795 13.5 14.7825 13.5Z",
    fill: "#DB353A",
    stroke: "#DB353A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightTextIcon);
export default __webpack_public_path__ + "static/media/highlight-text-icon.62e0779ff8316b6a1d7fb447505cdc47.svg";
export { ForwardRef as ReactComponent };